export default __webpack_public_path__ + "static/media/upsites_ecommerce.e8f49109.svg";